module.exports = __webpack_public_path__ + "img/illustration-section-01.49f7f076.svg";